module.exports = __webpack_public_path__ + "img/icon-7.7edaa660.png";